/* eslint-disable no-shadow */
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Img from '../../Img';
import {
    getPlayerName,
    getRatingDetails,
    setRatingChoice,
    getPickleBallRating,
} from '../../../utils';
import { titleCase } from '../../../utils/formatting';
import PopOverMenu from '../../PopOverMenu';
import BackgroundImage from '../../BackgroundImage';

import styles from './clubMemberCard.scss';
import PbrRating from '../../text/PbrRating';
import { displayBillingStatus, displayMembershipType } from '../../../utils/clubs';
import { gameTypes } from '../../../utils/constants';
import { MatchFormatTypes } from '../../../utils/postScoreConstants';
import { PlayersHeaderColumns } from '../../../pages/SearchPage/SortableColumnHeaders';
import CheckboxSA from '../../FormElementsStandalone/CheckboxSA';

export const ClubMemberCardTypes = {
    MEMBER: 'member',
    REQUEST: 'request',
    INVITE: 'invite',
    FORMER_MEMBER: 'formermember',
};

const ClubMemberCard = (props) => {
    const adminRoles = ['Admin', 'Owner'];
    const {
        forceCardView,
        menuOptions,
        menuOnSelected,
        userIsPowered,
        showDecimals,
        type,
        isAdminOrOwner,
        clubDetails,
        auth,
        sendMessage,
        hideMessageOption,
        selected,
        filters,
        showProjectedViewStatus,
        membersTabState,
        showCheckboxes,
        selectedMembers,
        onMemberSelected,
        index,
        'data-testid': dataTestId,
    } = props;

    const {
        firstName,
        lastName,
        gender,
        location,
        intialJoinDate,
        role,
        memberId,
        playerId,
        playerProfileImages,
        nationality,
        clubMemberTypeId,
        isPower,
        isPro,
        claimed,
    } = props.member;
    const {
        adminViewType,
    } = membersTabState;

    const showMembershipType = displayMembershipType(type, clubDetails);
    const showBillingStatus = displayBillingStatus(type, isAdminOrOwner, clubDetails);

    const nationalFlag = nationality ? `/img/flags/${nationality?.toLowerCase()}.svg` : '';

    const utrType = filters && filters.utrType === 'verified' ? 'sanctioned' : 'utr';
    const adminView = ['members', 'invites'];
    const getMemberDisplayRole = (role) => {
        if (role === 'Owner') {
            return 'Head Provider';
        } if (role === 'Admin') {
            return 'Provider';
        } if (role === 'FormerMember') {
            return 'Former Member';
        } if (role === 'FormerFollower') {
            return 'Former Follower';
        }
        return role;
    };

    const getMemberType = (typeId) => {
        switch (typeId) {
            case 1:
                return 'Physical Member';
            case 2:
                return 'Digital Member';
            default:
                return '';
        }
    };

    const getBillingStatus = (member) => {
        if (member.isPower || ((clubDetails.isEnterprise || clubDetails.isPremium || clubDetails.isProCollege) && adminRoles.includes(role))) {
            return 'Power (Club)';
        }
        if (member.isPowered) {
            return 'Power (Individual)';
        }
        return `Free`;
    };

    const Role = (props) => {
        const { cardType, role, cardView } = props;
        switch (cardType) {
            case ClubMemberCardTypes.REQUEST:
                if (role === 'Pending') {
                    return (
                        <div className={`${styles.approveRejectLayout} ${cardView ? styles.status : ''}`}>
                            <i
                                className={`uts uts-check-circle cursor-pointer ${styles.approve}`}
                                data-testid={dataTestId && `${dataTestId}.approve-btn`}
                                onClick={() => {
                                    props.approveOrRejectRequest('accept', props.member);
                                }}
                                title="Accept"
                            />
                            <i
                                className={`utr utr-close-circle cursor-pointer ${styles.reject}`}
                                data-testid={dataTestId && `${dataTestId}.reject-btn`}
                                onClick={() => {
                                    props.approveOrRejectRequest('reject', props.member);
                                }}
                                title="Reject"
                            />
                        </div>
                    );
                }
                if (cardView) {
                    return '';
                }
                return role;

            case ClubMemberCardTypes.INVITE:
                if (role === 'Pending') {
                    return 'Member';
                    // return (
                    //     <span
                    //         className={`text-teal cursor-pointer  ${cardView ? styles.status : ""}`}
                    //         onClick={(ev) => {
                    //             props.resendInvite("resend", props.clubDetails.id, props.member);
                    //         }}
                    //     >
                    //         Resend Invite
                    //     </span>
                    // )
                }
                if (cardView) {
                    return '';
                }
                return role;

            default:
                if (cardView) {
                    return '';
                }
                return getMemberDisplayRole(role);
        }
    };

    const getFormattedJoiningDate = (joinedDate) => {
        const momentJjoinedDate = moment(joinedDate);
        return momentJjoinedDate.format('MMM DD, YYYY');
    };
    const rating = getRatingDetails(setRatingChoice({ player: props.member }), userIsPowered, showDecimals, false, false);
    const singlesRating = getRatingDetails(setRatingChoice({ player: props.member, ratingType: gameTypes.SINGLES, utrType }), userIsPowered, showDecimals, false, showProjectedViewStatus);
    const doublesRating = getRatingDetails(setRatingChoice({ player: props.member, ratingType: gameTypes.DOUBLES, utrType }), userIsPowered, showDecimals, false, showProjectedViewStatus);
    const singlesPickleBallRating = getPickleBallRating(props.member, gameTypes.SINGLES);
    const doublesPickleBallRating = getPickleBallRating(props.member, gameTypes.DOUBLES);

    const isCurrentUser = auth && auth.user && (auth.user.id === memberId);
    const estimatedRating = 'Estimated';
    const projectedRating = 'Projected';
    const noUtrRating = '0.00';
    const notRated = 'UR';
    const reliableRating = 100;
    const pkbReliableRating = 'Reliable';
    const estimatedPkbRatings = ['P1', 'P2', 'P3', 'P4', 'P5'];
    const displayLabel = (ratingType, isPickleballRating) => {
        function formatDateString(dateString) {
            const months = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
            ];

            const date = new Date(dateString);
            const year = date.getFullYear().toString().slice(-2); // Extract the last two digits
            const month = months[date.getMonth()];

            return `${month} '${year}`;
        }
        if (ratingType === MatchFormatTypes.SINGLES && props.member?.ratingProgressSingles === reliableRating && !isPickleballRating) {
            return '';
        }
        if (ratingType === MatchFormatTypes.DOUBLES && props.member?.ratingProgressDoubles === reliableRating && !isPickleballRating) {
            return '';
        }
        if (ratingType === MatchFormatTypes.SINGLES && props.member?.singlesUtrDisplay !== noUtrRating && !isPickleballRating) {
            return projectedRating;
        }
        if (ratingType === MatchFormatTypes.DOUBLES && props.member?.doublesUtrDisplay !== noUtrRating && !isPickleballRating) {
            return projectedRating;
        }

        if (ratingType === MatchFormatTypes.SINGLES && props.member?.singlesPkbRatingDisplay !== null && isPickleballRating) {
            if (props.member?.singlesPkbRatingDisplay?.reliability === pkbReliableRating) { return ''; }
            return projectedRating;
        }
        if (ratingType === MatchFormatTypes.DOUBLES && props.member?.doublesPkbRatingDisplay !== null && isPickleballRating) {
            if (props.member?.doublesPkbRatingDisplay?.reliability === pkbReliableRating) { return ''; }
            return projectedRating;
        }

        if (ratingType === MatchFormatTypes.SINGLES && props.member.historicRatings?.historicSinglesRating && !isPickleballRating) {
            return formatDateString(props.member.historicRatings?.historicSinglesRatingDate);
        }
        if (ratingType === MatchFormatTypes.DOUBLES && props.member?.historicRatings?.historicDoublesRating && !isPickleballRating) {
            return formatDateString(props.member.historicRatings?.historicDoublesRatingDate);
        }

        if (ratingType === MatchFormatTypes.SINGLES && props.member?.historicPkbSinglesRating && isPickleballRating) {
            return formatDateString(props.member?.historicPkbSinglesRatingDate);
        }
        if (ratingType === MatchFormatTypes.DOUBLES && props.member?.historicPkbDoublesRating && isPickleballRating) {
            return formatDateString(props.member?.historicPkbDoublesRatingDate);
        }

        if (props.member?.utrRange?.minUtr && props.member?.utrRange?.maxUtr && !isPickleballRating) {
            return estimatedRating;
        }

        if (estimatedPkbRatings.includes(props.member?.utrRange?.pkbRatingDisplay) && isPickleballRating) {
            return estimatedRating;
        }
    };

    const displayNoRatingSymbol = () => {
        return (
            <img
                width={15}
                src={'/img/v3/icons/icon-no-ratings.svg'}
            />
        );
    };
    let ratingToDisplay;

    if (rating.showPBRRating) {
        if (rating.pbrRating === notRated) {
            ratingToDisplay = displayNoRatingSymbol();
        } else {
            ratingToDisplay = <PbrRating pbrRating={rating.pbrRating || notRated} />;
        }
    } else {
        ratingToDisplay = singlesRating.value === notRated
            ? displayNoRatingSymbol()
            : singlesRating.value;
    }
    const { sportTypes } = filters;
    const showTennisContent = auth?.feedPreferences?.showTennisContent;
    const showPickleballContent = auth?.feedPreferences?.showPickleballContent;
    const showTennisRating = sportTypes?.tennis || (!sportTypes?.tennis && !sportTypes?.pickleball && showTennisContent);
    const showPickleRating = sportTypes?.pickleball || (!sportTypes?.tennis && !sportTypes?.pickleball && showPickleballContent);
    let result;

    if (rating.showPBRRating) {
        if (rating.pbrRating === notRated) {
            result = displayNoRatingSymbol();
        } else {
            result = <PbrRating showValue={true} pbrRating={rating.pbrRating || notRated} />;
        }
    } else {
        result = singlesRating.value === notRated
            ? displayNoRatingSymbol()
            : singlesRating.value;
    }
    return (
        <div className={`${styles.memberCard} ${adminRoles.includes(role) ? styles.admin : ''} ${selected ? 'selected' : ''}`}>
            <div className={`${styles.listView} ${forceCardView ? 'd-none' : 'd-none d-md-flex'} ${isAdminOrOwner ? '' : styles.nonAdmin_listView_width}`}>
                <div className={`${styles.flexColumn} ${styles.playerDetailsContainer}`}>
                    <div
                        className={`${styles.playerName} ${styles.showEllipsis} ${playerId ? 'cursor-pointer' : ''}`}
                        data-testid={dataTestId && `${dataTestId}.desktop.player-name`}
                        onClick={() => {
                            if (playerId) {
                                window.location.href = `/profiles/${playerId}`;
                            }
                        }}
                    >
                        {titleCase(getPlayerName(firstName, lastName, false))}
                    </div>
                    <div className={`${styles.location} ${styles.showEllipsis}`} data-testid={dataTestId && `${dataTestId}.desktop.location`}>
                        {gender} {gender && (<span className={`${styles.middleDot}`}>&nbsp;</span>)} {location}
                    </div>
                </div>
                {showTennisRating && (
                    <div
                        className={`${styles.flexColumn} ${styles.utrContainer}`}
                        title={singlesRating.title}
                        data-testid={dataTestId && `${dataTestId}.desktop.singles-rating`}
                    >
                        <div className={`${styles.ratingValue} ${singlesRating.verified ? styles.sanctioned : ''}`} data-testid={dataTestId && `${dataTestId}.desktop.singles-rating.value`}>
                            {result}
                        </div>
                        {rating.showPBRRating ? rating.pbrRating !== notRated : singlesRating.value !== notRated && (
                            <div className={`${styles.utrType} ${styles.showEllipsis}`} data-testid={dataTestId && `${dataTestId}.desktop.singles-rating.label`}>
                                {displayLabel(MatchFormatTypes.SINGLES, false)}
                            </div>
                        )}
                    </div>
                )}
                {showTennisRating && (
                    <div
                        className={`${styles.flexColumn} ${styles.utrContainer}`}
                        title={doublesRating.title}
                        data-testid={dataTestId && `${dataTestId}.desktop.doubles-rating`}
                    >
                        <div className={`${styles.ratingValue} ${doublesRating.verified ? styles.sanctioned : ''}`} data-testid={dataTestId && `${dataTestId}.desktop.doubles-rating.value`}>
                            {doublesRating.value === notRated ? displayNoRatingSymbol() : doublesRating.value}
                        </div>
                        {doublesRating.value !== notRated && (
                            <div className={`${styles.utrType} ${styles.showEllipsis}`} data-testid={dataTestId && `${dataTestId}.desktop.doubles-rating.label`}>
                                {displayLabel(MatchFormatTypes.DOUBLES, false)}
                            </div>
                        )}
                    </div>
                )}
                {showPickleRating && (
                    <>
                        <div
                            className={`${styles.flexColumn} ${styles.utrContainer}`}
                            title={singlesPickleBallRating.title}
                            data-testid={dataTestId && `${dataTestId}.desktop.pkb-singles-rating`}
                        >
                            <div className={`${styles.ratingValue}`} data-testid={dataTestId && `${dataTestId}.desktop.pkb-singles-rating.value`}>
                                {singlesPickleBallRating.value === notRated ? displayNoRatingSymbol() : singlesPickleBallRating.value}
                            </div>
                            {singlesPickleBallRating.value !== notRated && (
                                <div className={`${styles.utrType} ${styles.showEllipsis}`} data-testid={dataTestId && `${dataTestId}.desktop.pkb-singles-rating.label`}>
                                    {displayLabel(MatchFormatTypes.SINGLES, true)}
                                </div>
                            )}
                        </div>
                        <div
                            className={`${styles.flexColumn} ${styles.utrContainer}`}
                            title={doublesPickleBallRating.title}
                            data-testid={dataTestId && `${dataTestId}.desktop.pkb-doubles-rating`}
                        >
                            <div className={`${styles.ratingValue}`} data-testid={dataTestId && `${dataTestId}.desktop.pkb-doubles-rating.value`}>
                                {doublesPickleBallRating.value === notRated ? displayNoRatingSymbol() : doublesPickleBallRating.value}
                            </div>
                            {doublesPickleBallRating.value !== notRated && (
                                <div className={`${styles.utrType} ${styles.showEllipsis}`} data-testid={dataTestId && `${dataTestId}.desktop.pkb-doubles-rating.label`}>
                                    {displayLabel(MatchFormatTypes.DOUBLES, true)}
                                </div>
                            )}
                        </div>
                    </>
                )}
                <div
                    className={`${styles.flexColumn} ${styles.roleContainer}`}
                    data-testid={dataTestId && `${dataTestId}.desktop.role-container`}
                >
                    <div className={`${styles.role} ${styles.showEllipsis} ${adminRoles.includes(role) ? styles.bold : ''}`} data-testid={dataTestId && `${dataTestId}.desktop.role`}>
                        {showMembershipType && adminRoles.includes(role) && (
                            <Role
                                cardType={type}
                                role={role}
                                approveOrRejectRequest={props.approveOrRejectRequest}
                                member={props.member}
                            />
                        )}
                        {!showMembershipType && (
                            <Role
                                cardType={type}
                                role={role}
                                approveOrRejectRequest={props.approveOrRejectRequest}
                                member={props.member}
                            />
                        )}
                    </div>
                    {showMembershipType && (
                        <div className={`${styles.membershipType} ${styles.showEllipsis}`} data-testid={dataTestId ? `${dataTestId}.desktop.membership-type` : 'club-profile.member.membership-type'}>
                            {getMemberType(clubMemberTypeId)}
                        </div>
                    )}
                </div>
                {showBillingStatus && (
                    <div
                        className={`${styles.flexColumn} ${styles.billingContainer} ${isPower ? styles.power : ''}`}
                    >
                        <span className={`ml16`}>
                            {getBillingStatus(props.member)}
                        </span>
                    </div>
                )}
                <div className={`${styles.flexColumn} ${styles.dateConatiner}`} data-testid={dataTestId && `${dataTestId}.desktop.join-date`}>
                    {getFormattedJoiningDate(intialJoinDate)}
                </div>
                {adminView.includes(adminViewType) && (
                    <div className={`${styles.sanctionedContainer} d-flex`}>
                        <div className="col-6 p0">
                            {(!isCurrentUser && !!memberId && !hideMessageOption && claimed &&
                                ((isPro && isAdminOrOwner) || !isPro)) && (
                                    <div className="click-area" data-testid={dataTestId && `${dataTestId}.message-btn`} onClick={() => sendMessage(props.member)}>
                                        <i className={`utr utr-message fs18 text-teal`} />
                                    </div>
                                )}
                        </div>
                        {menuOptions && menuOptions.length > 0 && (
                            <div className="col-6 p0">
                                <PopOverMenu
                                    horizontalEllipsis={false}
                                    menuItems={menuOptions}
                                    onSelected={menuOnSelected}
                                    data-testid={dataTestId && `${dataTestId}.desktop.menu`}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className={`${styles.cardView} ${forceCardView ? 'd-block' : 'd-block d-md-none'}`}>
                <div className={`${styles.header}`}>
                    {isAdminOrOwner && showCheckboxes && (
                        <div className={`mt20`}>
                            <CheckboxSA
                                checked={selectedMembers[index]}
                                onChange={() => onMemberSelected(index)}
                                data-testid={dataTestId && `${dataTestId}.checkbox`}
                            />
                        </div>
                    )}
                    <div className={`${styles.avatarContainer} ${styles.flexColumn} ml0`}>
                        <BackgroundImage
                            baseUrl={'/v1/player/'}
                            defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                            images={playerProfileImages}
                            imageType={'icon'}
                            parentStylesClass={styles.avatar}
                        />
                        {nationality && (
                            <div className={styles.flagContainer}>
                                <Img
                                    className={`${styles.flag}`}
                                    src={nationalFlag}
                                />
                            </div>
                        )}
                    </div>
                    <div className={`${styles.playerDetailsContainer} ${styles.flexColumn}`}>
                        <div className={`${styles.nameContainer}`}>
                            <div
                                className={`${styles.name} ${styles.flexColumn}`}
                                data-testid={dataTestId && `${dataTestId}.mobile.name`}
                                onClick={() => {
                                    if (playerId) {
                                        window.location.href = `/profiles/${playerId}`;
                                    }
                                }}
                            >
                                <span className="">{firstName}</span> {lastName}
                            </div>
                            {type === ClubMemberCardTypes.MEMBER && adminRoles.includes(role) && (
                                <div className={`btn btn-sm ${styles.tag}`} data-testid={dataTestId && `${dataTestId}.mobile.role-tag`}>
                                    <div className={`ellipsis`}>
                                        {getMemberDisplayRole(role)}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={`${styles.location} ${styles.showEllipsis}`} data-testid={dataTestId && `${dataTestId}.mobile.location`}>
                            {gender} {gender && (<span className={`${styles.middleDot}`}>&nbsp;</span>)} {location}
                        </div>
                        {showMembershipType && (
                            <div className={`${styles.membershipType} ${styles.showEllipsis}`} data-testid={dataTestId && `${dataTestId}.mobile.membership-type`}>
                                {getMemberType(clubMemberTypeId)}
                            </div>
                        )}
                    </div>
                    <div className={`${styles.avatarContainer} ${styles.flexColumn} pl4`}>

                        <div className="col-6 p0 d-block d-md-none">
                            {(!isCurrentUser && !!memberId && !hideMessageOption && claimed &&
                                ((isPro && isAdminOrOwner) || !isPro)) && (
                                    <div className="click-area" data-testid={dataTestId && `${dataTestId}.message-btn`} onClick={() => sendMessage(props.member)}>
                                        <i className={`utr utr-message fs18 text-teal`} />
                                    </div>
                                )}
                        </div>
                    </div>

                </div>

                <div className="divider" />
                <PlayersHeaderColumns
                    filterType={'players'}
                    players={props.clubDetails.clubMembers}
                    utrType={utrType}
                    userLoggedIn={auth.user}
                    sportTypes={sportTypes}
                    showFilterDropDown="hide"
                    showHeaderColumnsInMobile={true}
                    isClubMemberOrAdmin={true}
                    isMobileView={true}
                />
                <div className={`${styles.footer}`}>
                    {showTennisRating && (
                        <div className={`${styles.values} ${styles.flexColumn}`} style={{ marginLeft: '0' }}>
                            <div
                                className={`${styles.value} ${styles.showEllipsis} ${styles.ratingValue} ${singlesRating.verified ? styles.sanctioned : ''}`}
                            >
                                {ratingToDisplay}
                            </div>
                            {rating.showPBRRating ? rating.pbrRating !== notRated : singlesRating.value !== notRated && (
                                <div
                                    className={`${styles.title} ${styles.showEllipsis}`}
                                >
                                    {displayLabel(MatchFormatTypes.SINGLES, false)}

                                </div>
                            )}
                        </div>
                    )}
                    {showTennisRating && (
                        <div className={`${styles.values} ${styles.flexColumn}`} style={{ marginLeft: '0' }}>
                            <div
                                className={`${styles.value} ${styles.showEllipsis} ${styles.ratingValue} ${doublesRating.verified ? styles.sanctioned : ''}`}
                            >
                                {!rating.showPBRRating && doublesRating.value === notRated ? displayNoRatingSymbol() : doublesRating.value}
                            </div>
                            {doublesRating.value !== notRated && (
                                <div
                                    className={`${styles.title} ${styles.showEllipsis}`}
                                >
                                    {displayLabel(MatchFormatTypes.DOUBLES, false)}

                                </div>
                            )}

                        </div>
                    )}
                    {showPickleRating && (
                        <div className={`${styles.values} ${styles.flexColumn}`} style={{ marginLeft: '0' }}>
                            <div
                                className={`${styles.value} ${styles.ratingValue}`}
                            >
                                {singlesPickleBallRating.value === notRated ? displayNoRatingSymbol() : singlesPickleBallRating.value}
                            </div>
                            {singlesPickleBallRating.value !== notRated && (
                                <div
                                    className={`${styles.title} ${styles.showEllipsis}`}
                                >
                                    {displayLabel(MatchFormatTypes.SINGLES, true)}
                                </div>
                            )}
                        </div>
                    )}
                    {showPickleRating && (
                        <div className={`${styles.values} ${styles.flexColumn}`} style={{ marginLeft: '0' }}>
                            <div
                                className={`${styles.value} ${styles.ratingValue}`}
                            >
                                {doublesPickleBallRating.value === notRated ? displayNoRatingSymbol() : doublesPickleBallRating.value}
                            </div>
                            {doublesPickleBallRating.value !== notRated && (
                                <div
                                    className={`${styles.title} ${styles.showEllipsis}`}
                                >
                                    {displayLabel(MatchFormatTypes.DOUBLES, true)}
                                </div>
                            )}
                        </div>
                    )}
                    <div className={`${styles.sanctionedContainer}  d-flex`}>
                        <div className="col-6 p0 d-none d-md-block">
                            {(!isCurrentUser && !!memberId && !hideMessageOption && claimed &&
                                ((isPro && isAdminOrOwner) || !isPro)) && (
                                    <div className="click-area" data-testid={dataTestId && `${dataTestId}.message-btn`} onClick={() => sendMessage(props.member)}>
                                        <i className={`utr utr-message fs18 text-teal`} />
                                    </div>
                                )}
                        </div>
                        {menuOptions && menuOptions.length > 0 && (
                            <div className={`col-6 p0 pt2 ${styles.popOverMenu}`}>
                                <PopOverMenu
                                    horizontalEllipsis={false}
                                    menuItems={menuOptions}
                                    onSelected={menuOnSelected}
                                    data-testid={dataTestId && `${dataTestId}.mobile.menu`}
                                />
                            </div>
                        )}
                    </div>
                </div>
                {type === ClubMemberCardTypes.REQUEST && role === 'Pending' && (
                    <>
                        <div className={styles.divider} />
                        <div className={`${styles.pendingLayout} ${styles.approveRejectLayout}`}>
                            <div
                                className={`cursor-pointer ${styles.approve}`}
                                data-testid={dataTestId && `${dataTestId}.mobile.approve-btn`}
                                onClick={() => {
                                    props.approveOrRejectRequest('accept', props.member);
                                }}
                            >
                                <i
                                    className="fas fa-check"
                                    title="Accept"
                                />
                                Accept request
                            </div>
                            <div
                                className={`cursor-pointer ${styles.reject}`}
                                data-testid={dataTestId && `${dataTestId}.mobile.reject-btn`}
                                onClick={() => {
                                    props.approveOrRejectRequest('reject', props.member);
                                }}
                            >
                                <i
                                    className="uts uts-close"
                                    title="Reject"
                                />
                                Reject request
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

ClubMemberCard.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    member: PropTypes.instanceOf(Object),
    filters: PropTypes.instanceOf(Object),
    clubDetails: PropTypes.shape({
        clubMembers: PropTypes.any,
    }),
    showCheckboxes: PropTypes.bool,
    selectedMembers: PropTypes.arrayOf(PropTypes.any).isRequired,
    index: PropTypes.number.isRequired,
    onMemberSelected: PropTypes.func.isRequired,
};

ClubMemberCard.defaultProps = {
    filters: null,
    member: null,
    clubDetails: null,
    showCheckboxes: false,
    'data-testid': null,
};
export default ClubMemberCard;
